import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import tw from "twin.macro";
import { Container as BaseContainer } from "../section";
import contacts from "./contacts";
import AppLink from "../app-link";

const ContactGroupContainer = tw.div`mb-8`;
const ContactGroupHeading = tw.h2`text-red-900 uppercase border-l-8 pl-2 border-red-900 font-bold mt-4 mb-2`;
const Container = tw(BaseContainer)`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-2 lg:grid-flow-col`;

const Contact = tw.div`text-sm`;
const ContactHeading = tw.h4`font-bold mt-4`;
const ContactDetail = tw.p``;
const PhoneNumber = tw.a`whitespace-no-wrap`;

const ContactList = () => {
  const laos = useStaticQuery(graphql`
    query {
      allLaosJson(filter: { type: { eq: "lao" } }) {
        edges {
          node {
            name
            org
            contact {
              name
              email
              phone
              role
            }
          }
        }
      }
    }
  `);

  const allContacts = [
    ...contacts,
    {
      title: "Lead Academic Organization Contacts",
      contacts: laos.allLaosJson.edges.map(edge => {
        const lao = edge.node;
        lao.title = `${lao.org}, ${lao.name}`;
        lao.name = lao.contact.name;
        lao.email = lao.contact.email;
        lao.phone = lao.contact.phone;
        lao.role = lao.contact.role;
        return lao;
      })
    }
  ];

  // CLUDGE: The first two groups are small so they are manually
  // grouped on larger screens
  return (
    <Container>
      {allContacts.map((group, i) =>
        i <= 1 ? (
          <ContactGroup group={group} key={group.title} />
        ) : (
          <div tw="row-span-2" key={group.title}>
            <ContactGroup group={group} />
          </div>
        )
      )}
    </Container>
  );
};

const ContactGroup = ({ group }) => (
  <ContactGroupContainer>
    <ContactGroupHeading>{group.title}</ContactGroupHeading>
    {group.contacts.map((contact, i) => (
      <Contact key={`contact-${i}`}>
        <ContactHeading>{contact.title}</ContactHeading>
        <ContactDetail>
          <AppLink href={`mailto:${contact.email}`}>
            {contact.name ? contact.name : contact.email}
          </AppLink>
          {contact.role && `, ${contact.role}`}
          {contact.phone ? (
            <>
              ,{" "}
              <PhoneNumber
                href={`tel:+1${contact.phone.replace(/[^0-9]/g, "")}`}
              >
                {contact.phone}
              </PhoneNumber>
            </>
          ) : (
            ""
          )}
        </ContactDetail>
      </Contact>
    ))}
  </ContactGroupContainer>
);

ContactGroup.propTypes = {
  group: PropTypes.object
};

export default ContactList;
